import withSpinner from './withSpinner';
export default withSpinner;
